// extracted by mini-css-extract-plugin
export default {"select":"Prediction_select__AqHx+"};